// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"e2fa3861","160":"971ad549","181":"c7bc39fb","368":"ae1c6444","407":"7f7dc877","440":"4f45ae57","488":"551e7158","495":"61640a67","574":"ca104398","613":"dc20a20e","891":"5e2633d8"}[chunkId] + ".chunk.js";
};